import styled from 'styled-components/macro';
import {useState} from "react";
import {useToast} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useCreateReply} from "../api/message";
import Button from "./button";
import MarkdownField from "./markdown_field";
import ErrorMessage from "./error_message";
import Spinner from "./spinner";
import {themecolors} from "../utils/themecolors";

const Save = styled.div``;

const CreateReply = styled(({className, message, comment, setReply, onClose}) => {
    const creating = useFeedback();
    const toast = useToast();
    const [content, setContent] = useState('');
    const createReply = useCreateReply(creating.channel);
    const {conversation_id} = message;
    const [posting, setPosting] = useState(false);
    const handleSend = async () => {
        if (posting) return;
        try {
            setPosting(true);
            await createReply(conversation_id, content);
            setReply(false);
            toast({
                title: 'Your message has been sent!',
                status: 'success',
                isClosable: true,
            });
        } catch {
            // error is displayed
            toast({
                title: 'Something went wrong.',
                status: 'error',
                isClosable: true,
            })
        }
        setPosting(false);
    };
    return (
        <div className={className}>
            <MarkdownField
                id='content' placeholder="Add your message" minRows={5}
                value={content} onChange={setContent} autofocus
            />
            <Save>
                <ErrorMessage error={creating.error}/>
                {creating.busy && <Spinner/>}
                <Button onClick={onClose} disabled={creating.busy} tabindex={-1}>Cancel</Button>
                <Button onClick={handleSend} disabled={creating.busy}>Save</Button>
            </Save>
        </div>
    )
})`
  margin-top: 16px;
  max-width: 464px;

  ${Save} {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    font-size: 14px;
  }
  ${Save} button {
    margin-left: 12px;
    padding: 8px 16px;
    border-radius: 48px;
    ${({theme}) => `
        color: ${theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
        background-color: ${theme.color.name === 'dark' ? theme.dark_border : '#ececec'};
    `}
  }
  ${Save} button:first-of-type {
    background-color: transparent;
    border: none;
    padding: 8px 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text: themecolors.light_low_impact_text};
  }

  @media only screen and (max-width: 780px) {
    & {
      margin-left: 0;
      width: 100%;
    }
  }
`;

export default CreateReply;
